import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";

const FieldError = ({ error, className, icon = false }) => {
  return (
    <>
      {error && (
        <p className={`text-red-500 text-sm mb-2 mt-2 pb-2 pl-1 ${className}`}>
          {icon && (
            <FontAwesomeIcon icon={faExclamationCircle} className="mt-2 mr-1" />
          )}
          {error.message}
        </p>
      )}
    </>
  );
};

export default FieldError;
